import Exception from 'app/errors/exception';

export default class InvalidStateException extends Exception
{
}
